import { type FC, useMemo } from "react";
import { BarGraphBar, type BarGraphBarProps } from "./BarGraphBar";

interface BarGraphEntry {
  label: string;
  value: number;
  displayAs?: string; // Override the way the value is displayed. For example to add a percent sign.
}

interface BarGraphStyleCondition {
  min: number;
  max: number;
  style: BarGraphBarProps["style"];
}

interface BarGraphProps {
  data: BarGraphEntry[];
  max?: number; // Maximum value for displaying, will default to the maximum value of the given entries
  styleConditions?: BarGraphStyleCondition[];
}

export const BarGraph: FC<BarGraphProps> = (props) => {
  const maximum = useMemo(() => {
    return props.max ?? Math.max(...props.data.map((d) => d.value));
  }, [props.max, props.data]);

  return (
    <table className={"w-full"}>
      <tbody>
        {props.data.map((entry, i) => {
          const style =
            props.styleConditions?.find((c) => {
              return c.min <= entry.value && c.max >= entry.value;
            })?.style ?? "default";
          return (
            <tr key={i}>
              <td className={"whitespace-nowrap text-right"}>{entry.label}</td>
              <td className={"w-full px-3 pb-2"}>
                <BarGraphBar value={entry.value / maximum} style={style} size={"h-3"} />
              </td>
              <td className={"whitespace-nowrap text-right"}>{entry.displayAs ?? entry.value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
